import { useEffect } from "react"
import BookingWizardPage from "@/pages/BookingWizard"
import { useBookingStore } from "@/store/booking-store"

export default function BookingServicePage() {
  // Backward-compatible route: render the single-page wizard
  // and force the wizard to the service step.
  const { setBookingState } = useBookingStore()

  useEffect(() => {
    setBookingState({ bookingStep: "service" })
  }, [setBookingState])

  return <BookingWizardPage />
}
